
    import Vue from "vue";
    import { PersonService } from "@/services/PersonService";
    import { GroupService } from "@/services/GroupService";
    import GroupRegistrationRequest from "@/models/api/group/GroupRegistrationRequest";
    import VuetifyFormMethods from "@/models/vuetify-form-methods";
    import { AxiosError } from "axios";
    import { SnackbarService } from "@/services/SnackbarService";
    import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
    import AddParticipantDialog from "@/components/dialogs/AddParticipantDialog.vue";
    import EditParticipantDialog from "@/components/dialogs/EditParticipantDialog.vue";
    import Group, { GroupList } from "@/models/api/group/Group";
    import { ActivityService } from "@/services/ActivityService";
    import Activity from "@/models/api/activity/Activity";
    import AssociationActivity from "@/models/api/association/AssociationActivity";
    import ParticipantGroupRegistrationRequest from "@/models/api/participant-group/ParticipantGroupRegisterRequest";
    import { ParticipantService } from "@/services/ParticipantService";
    import Person from "@/models/api/person/Person";
    import PersonRegistrationRequest from "@/models/api/person/PersonRegistrationRequest";
    import { DataTableHelper } from '../../helpers/DataTableHelper';
    import { mapGetters } from 'vuex';
    import IsDirtyHandler from '@/components/ui/IsDirtyHandler';
import { AssociationRoleEnum } from '../../models/Enums';

    export default IsDirtyHandler.extend({
        components: {
            DeleteDialog,
            AddParticipantDialog,
            EditParticipantDialog,
        },
        data() {
            return {
                pageHeader: "Grupper",
                groups: new Array<GroupList>(),
                activities: new Array<AssociationActivity>(),

                groupTableHeaders: [
                    { text: "name", value: "name" },
                    { text: "activity.activity", value: "activityName" },
                    { text: "group.participants", value: "numberOfParticipants" },
                    { text: "group.leaders", value: "numberOfLeaders" },
                    { text: "", sortable: false, align: "end", value: "actions" },
                ],
                isTableLoading: false,

                participantGroupTableHeaders: [
                    {
                        text: "", sortable: false, align: 'center', value: "added",
                        width: '1%',
                        class: 'slimDataTableColumnPaddingLeft',
                        cellClass: 'slimDataTableColumnPaddingLeft',
                    },
                    { text: "person.firstName", value: "person.firstName" },
                    { text: "person.lastName", value: "person.lastName" },
                    { text: "person.socialSecurityNumber", value: "person.socialSecurityNumber" },
                    {
                        text: "group.isDisabledShort",
                        value: "isDisabled",
                        //width: '1%',
                        class: 'slimDataTableColumnPaddingLeft',
                        cellClass: 'slimDataTableColumnPaddingLeft',
                        align: 'center',
                    },
                    {
                        text: "group.isLeader",
                        value: "isLeader",
                        //width: '1%',
                        class: 'slimDataTableColumnPaddingLeft',
                        cellClass: 'slimDataTableColumnPaddingLeft',
                        align: 'center',
                    },
                    {
                        text: "group.isAdmin",
                        value: "isAdmin",
                        //width: '1%',
                        class: 'slimDataTableColumnPaddingLeft',
                        cellClass: 'slimDataTableColumnPaddingLeft',
                        align: 'center',
                    },
                    {
                        text: "",
                        sortable: false,
                        align: 'end',
                        value: "actions"
                    },
                ],
                isTableLoadingParticipantGroup: false,


                addPersonsTableHeaders: [
                    { text: "person.firstName", value: "firstName" },
                    { text: "person.lastName", value: "lastName" },
                    { text: "person.socialSecurityNumber", value: "socialSecurityNumber" },
                ],
                isTableLoadingAddPersons: false,
                dialogOpenAddPersons: false,

                itemsAddPersons: [] as Person[],
                selectedAddPersons: [] as Person[],
                selectedGroupAddPersons: null as number | null,


                // Dialogs
                dialogOpen: false,
                addParticipantDialogOpen: false,

                registrationRequest: new GroupRegistrationRequest("", -1, -1, [], ""),
                groupFormValid: false,

                showDeleteDialog: false,
                itemToDeleteId: "",
                itemToDeleteName: "",

                showDeleteDialogParticipant: false,
                itemToDeleteIdParticipant: "",
                itemToDeleteNameParticipant: "",

                editParticipantDialogOpen: false,          
                itemIdToBeEdited: null,

                windowWidth: 650,
            };
        },
        created() {
            window.addEventListener('resize', this.resize);
            DataTableHelper.adaptTableHeaders(this.participantGroupTableHeaders, this);
            DataTableHelper.adaptTableHeaders(this.groupTableHeaders, this);
            DataTableHelper.adaptTableHeaders(this.addPersonsTableHeaders, this);
            this.getGroups();
            this.getActivities();
            this.resize();
        },
        watch: {
            dialogOpen: {
                handler(open: boolean) {
                    if (!open) {
                        (this.$refs.groupForm as VuetifyFormMethods).reset();
                    }
                },
            },
            editDialogOpen: {
                handler(open: boolean) {
                    if (!open) {
                        (this.$refs.editForm as VuetifyFormMethods).reset();
                    }
                },
            },
            // Is dirty handling for group edit
            registrationRequest: {
                handler(change: any) {
                    this.isDirtyChangeTracker(change);
                },
                deep: true,
            }
        },
        computed: {
            computedParticipantGroupTableHeaders(): any {
                return this.participantGroupTableHeaders.filter((h: any) => !h.hide || !(this as any).$vuetify.breakpoint[h.hide]);
            },
            ...mapGetters([
                "isSystemAdmin",
                "isMunicipalityAdmin",
                "isAssociationUser_Admin",
                "isAssociationUser_GroupAdmin",
            ]),
            
        },
        methods: {
            resize() {
                this.windowWidth = window.innerWidth;
                //console.log("Width: " + this.windowWidth);
            },
            closeDialog() {
                if (this.isDirtyCheck()) {
                    this.dialogOpen = false;
                    this.registrationRequest = new GroupRegistrationRequest('', -1, -1, [], "");
                }
            },
            removeParticipant(id: number) {
                this.showDeleteDialogParticipant = false;
                if (id != null) {
                    const index = this.registrationRequest.participantGroups.findIndex(x => x.id == id);

                    this.registrationRequest.participantGroups.splice(index, 1);
                }
            },
            addParticipant(participant: ParticipantGroupRegistrationRequest) {
                //console.log("adding participant", participant);

                if (this.registrationRequest.participantGroups.some((s: ParticipantGroupRegistrationRequest) => s.personId == participant.personId)) {
                    SnackbarService.addErrorMessage(
                        "Personen finns redan som medlem!"
                    );
                } else {
                    this.registrationRequest.participantGroups.push(participant);
                    this.addParticipantDialogOpen = false;
                }
            },
            updatedParticipant(participant: ParticipantGroupRegistrationRequest){

                console.log(this.registrationRequest.participantGroups);
                console.log(participant);

                if (this.registrationRequest.participantGroups.some((s: ParticipantGroupRegistrationRequest) => s.personId == participant.personId)) {

                    const isDirty = this.getIsDirty();

                    const index = this.registrationRequest.participantGroups.findIndex(x => x.personId == participant.personId);
              
                    const pers = this.registrationRequest.participantGroups[index].person;

                    if (pers != null) { 

                        var hasChanged = false;

                        if (pers.firstName != participant.person?.firstName) {
                            hasChanged = true;
                            pers.firstName = participant.person?.firstName ?? "";
                        }

                        if (pers.lastName != participant.person?.lastName) {
                            hasChanged = true;
                            pers.lastName = participant.person?.lastName ?? "";
                        }

                        if (pers.email != participant.person?.email) {
                            hasChanged = true;
                            pers.email = participant.person?.email ?? "";
                        }

                        if (hasChanged && !isDirty) {
                            this.$nextTick(() => { this.isDirtyReset(); });                          
                        }
                    }

                    this.editParticipantDialogOpen = false;      
                 
                }
            },

            getParticipant(person: Person): ParticipantGroupRegistrationRequest {
                const participant = new ParticipantGroupRegistrationRequest(0, person.id, 0, person.isDisabled, false, false, person.associationRole == AssociationRoleEnum.AssociationAdmin ? true : false);

                participant.person = person;

                return participant;
            },
            addPersons(): void {
                //console.log("selectedAddPersons");
                //console.log(this.selectedAddPersons);


                const participantGroups = this.selectedAddPersons.map((s: Person) => this.getParticipant(s));

                participantGroups.forEach((participant: ParticipantGroupRegistrationRequest) => {
                    if (this.registrationRequest.participantGroups.some((s: ParticipantGroupRegistrationRequest) => s.personId == participant.personId)) {
                        SnackbarService.addErrorMessage(
                            "Personen " + participant.person?.firstName + " " + participant.person?.lastName + " finns redan som medlem!"
                        );
                    } else {
                        this.registrationRequest.participantGroups.push(participant);
                    }
                });

                this.dialogOpenAddPersons = false;
            },
            isInGroup(personId: number): boolean {
                return this.registrationRequest.participantGroups.some(s => s.personId == personId);
            },
            getPersons() {
                this.isTableLoadingAddPersons = true;
                PersonService.GetPersonsForAddToGroup(this.selectedGroupAddPersons).then(response => {
                    this.selectedAddPersons = [] as Person[];
                    this.itemsAddPersons = response.data;

                    this.itemsAddPersons.forEach((s: any) => s.isSelectable = !this.isInGroup(s.id));

                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                    .finally(() => {
                        this.isTableLoadingAddPersons = false;
                    });
            },

            prepareAddPersons(): void {
                this.selectedAddPersons = [] as Person[];
                this.selectedGroupAddPersons = null;
                this.dialogOpenAddPersons = true;
                this.getPersons();
            },
            prepareGroupEdit(item: Group): void {
                // Use object assign in order to separate the modified item with existing item.
                // Keeps row in datatable the same, whilst updating the values.
                this.$store.commit('addOverlay');
              
                GroupService.GetGroup(item.id).then(response => {
                    this.registrationRequest = response.data;
                    this.resize();
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                    .finally(() => {
                        this.$store.commit('removeOverlay');
                    });
                
            },
            async saveGroup(request: Group) {
                request.confirmEmailUrl = window.location.href.substr(0, window.location.href.lastIndexOf("#") + 1) + "/confirmUser";

                GroupService.EditGroup(request).then(
                    (result) => {
                        console.log(result);
                        let showSuccess = true;

                        if (Array.isArray(result.data.informations) && result.data.informations.length) {
                            result.data.informations.forEach((message: string) => SnackbarService.addWarningMessage(
                                message));
                            showSuccess = false;
                        }

                        if (Array.isArray(result.data.errors) && result.data.errors.length) {
                            result.data.errors.each((message: string) => SnackbarService.addErrorMessage(
                                message));
                        } else {
                            this.registrationRequest = new GroupRegistrationRequest("", -1, -1, [], "");

                            this.getGroups();
                            this.dialogOpen = false;

                            if (showSuccess) {
                                SnackbarService.addSuccessMessage(result?.data.message);
                            }
                        }
                    },
                    (error: AxiosError) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            },
            async removeGroup(id: number) {
                this.showDeleteDialog = false;

                if (id != null) {
                    GroupService.RemoveGroup(id).then(
                        (result) => {
                            SnackbarService.addSuccessMessage(result?.data);

                            console.log(result);
                            this.getGroups();
                        },
                        (error: AxiosError) => {
                            console.log(error);

                            SnackbarService.addErrorMessage(
                                error.response?.data || error.response?.statusText
                            );
                        }
                    );
                }
            },
            async editGroup(itemToUpdate: Group) {
                itemToUpdate.confirmEmailUrl = window.location.href.substr(0, window.location.href.lastIndexOf("#") + 1) + "/confirmUser";

                GroupService.EditGroup(itemToUpdate).then(
                    (result) => {
                        console.log(result);
                        let showSuccess = true;

                        if (Array.isArray(result.data.informations) && result.data.informations.length) {
                            result.data.informations.forEach((message: string) => SnackbarService.addWarningMessage(
                                message));
                            showSuccess = false;
                        }

                        if (Array.isArray(result.data.errors) && result.data.errors.length) {
                            result.data.errors.each((message: string) => SnackbarService.addErrorMessage(
                                message));
                        } else {
                            this.registrationRequest = new GroupRegistrationRequest("", -1, -1, [], "");

                            this.getGroups();
                            this.dialogOpen = false;

                            if (showSuccess) {
                                SnackbarService.addSuccessMessage(result?.data.message);
                            }
                        }
                    },
                    (error: AxiosError) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            },
            async getGroups() {
                this.isTableLoading = true;

                this.groups = (await GroupService.GetGroups()).data;

                this.isTableLoading = false;
            },
            getActivities() {
                ActivityService.GetAssociationActivities().then(
                    (result) => {
                        this.activities = result.data;

                        //console.log(this.activities);
                        
                    },
                    (error: AxiosError) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            },
            // rules
            uniqueGroupName(name: string): string | boolean {
                // Filter new name except from the item being edited.
                if (this.registrationRequest?.name &&
                    this.groups
                        .filter((x) => x.id != this.registrationRequest.id)
                        .some((f) => {
                            //console.log(f);
                            //console.log(name);
                                return f.name.trim().toLocaleLowerCase() ==
                                this.registrationRequest.name.trim().toLocaleLowerCase();
                            })
                ) {
                 //   return `Det finns redan en förening med namnet: ${name}`;
                    return this.$vuetify.lang.t('$vuetify.group.nameAlreadyExists') + " " + name;
                }

                return true;
            },
            
        },
    });
